<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text"
                               :placeholder="$t('main.search')"
                               v-model="filter.search"
                               @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="showGasPriceAdd(null)" v-if="hasPermission('SETTINGS_GAS_DEVICE_PRICE_ADD')">{{$t("action.add")}}</button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>ID</th>
                      <th>Яратилган сана</th>
                      <th>Яратган фойдаланувчи</th>
                      <th>Тури</th>
                      <th>Қиймати</th>
                      <th>Манба</th>
                      <th>Манба</th>
                      <th class="text-center">
                          {{$t("realEstate.field.action")}}
                      </th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>
                          <span v-if="result.createDate">
                              {{new Date(result.createDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}
                          </span>
                      </td>
                      <td>{{result.createUserName}}</td>
                      <td>{{result.gasDeviceType === 'METHANE' ? 'МЕТАН' : (result.gasDeviceType === 'PROPANE' ? 'ПРОПАН' : '')}}</td>
                      <td>{{result.price}}</td>
                      <td>{{result.source}}</td>
                      <td>
                        <span class="badge badge-success" v-if="result.visibleState==='ACTIVE'">{{ result.visibleState }}</span>
                        <span class="badge badge-secondary"
                              v-else-if="result.visibleState==='DEACTIVATED'">{{ result.visibleState }}</span>
                        <span class="badge badge-danger" v-else>{{ result.visibleState }}</span>
                      </td>
                      <td class="td-actions text-center">
                          <button v-if="result.visibleState==='ACTIVE'" class="all-btn view-btn table-action" v-tooltip="'Кўриш'" @click="showGasPriceAdd(result)">
                              <i class="fa fa-image"></i>
                          </button>
                      </td>
                    <td class="td-actions text-center">
                      <button  v-if="result.visibleState==='ACTIVE'" type="button" v-tooltip="'Ўчириш'"
                              class="all-btn delete-btn table-action"
                              @click="gasPriceDelete(result)">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <gas-device-price-add-view />
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import GasDevicePriceAddView from '@/views/config/auto/GasDecicePriceAddView';

    export default {
        name: "GasDevicePrice",
        components: {
            GasDevicePriceAddView,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('auto-gas-price/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showGasPriceAdd(data) {
                if (data && data.id) {
                    const vm = this;
                    vm.$http.get('auto-gas-price/' + data.id)
                        .then(res => {
                            vm.loading = false;
                            if (res.data.status === 'SUCCESS') {
                                vm.show = false;
                                this.$eventBus.$emit('showGasPriceAdd', res.data.data);
                            }
                        }, err => {
                            vm.loading = false;
                            console.log(err);
                        });
                } else {
                    this.$eventBus.$emit('showGasPriceAdd', null);
                }
            },
            gasPriceDelete(data) {
              if (data && data.id) {
                const vm = this;
                vm.$http.get('auto-gas-price/gas-deactivated/' + data.id)
                    .then(res => {
                      vm.loading = false;
                      if (res.data.status === 'SUCCESS') {
                        window.location.reload();
                      }
                    }, err => {
                      vm.loading = false;
                      console.log(err);
                    });
              }
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('gasPriceChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>